import { Box, Typography } from "@mui/material";
import { useTraderProvider } from "../../providers/TraderProvider";
import { useAffiliateProvider } from "../../providers/AffiliateProvider";
import { useTranslation } from "react-i18next";
const TotalEurosMade = () => {
	const { totalEurosMade } = useAffiliateProvider();
	const { t } = useTranslation();

	return (
		<>
			<Box
				flex={1}
				minWidth="200px"
				maxWidth="376px"
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexDirection: "column",
					padding: "16px",
					borderRadius: "8px",
					margin: "8px",
				}}
				className="trader-credits-to-be-paid"
			>
				<Typography variant="body1" fontSize="24px">
					{t("affiliate.total_earned")}
				</Typography>
				<Typography variant="body1" fontSize="40px" fontWeight="bold">
					{(totalEurosMade / 100).toFixed(2)}€
				</Typography>
			</Box>
		</>
	);
};

export default TotalEurosMade;
